import { BoxTitles } from "@boxes/BoxTitles";
import { BaseCurrencyInput, Button, Drawer, Select } from "@components";
import { useEffect, useState } from "react";

import styles from "@styles/forms-flow/filtered-audience.module.scss";

export const RegisterTimeFilterForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
}) => {
  const [inLast, setInLast] = useState(node.data.inLast || null);
  const [inLastPeriod, setInLastPeriod] = useState(
    node.data.inLastPeriod || "DAY"
  );

  const [inclusive, setInclusive] = useState(
    node.data.inclusive !== undefined ? !!node.data.inclusive : true
  );

  const getFreshNode = () => {
    return {
      ...node,
      data: { ...(node?.data || {}), inLast, inLastPeriod, inclusive },
    };
  };

  useEffect(() => {
    onChange && onChange(getFreshNode());
  }, [inLast, inLastPeriod]);

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={BoxTitles.RegisterTimeFilter}
    >
      <p className={styles.label}>Determine o período</p>
      <div className={styles.customPeriod}>
        <p>Nos últimos</p>

        <div className="d-flex mb-20">
          <BaseCurrencyInput
            placeholder="Inserir valor"
            className="w-50"
            precision={0}
            prefix=""
            type="tel"
            value={inLast}
            onChange={(v) => setInLast(v)}
          />
          <Select
            title="Selecione o tempo..."
            className="w-50 ml-15"
            value={inLastPeriod}
            options={[
              { label: "Dias", value: "DAY" },
              { label: "Meses", value: "MONTH" },
              { label: "Anos", value: "YEAR" },
            ]}
            onChange={(e) => setInLastPeriod(e.target.value)}
          />
        </div>
      </div>

      <div className={styles.footer}>
        <Button
          design="primary"
          className="w-100"
          onClick={() => onSave(getFreshNode())}
        >
          Salvar
        </Button>
      </div>
    </Drawer>
  );
};
